'use strict';
const angular = require('angular');

export class userAddComponent {

  constructor(User, dialogs, $scope, SettingsService, Config) {
    'ngInject';

    this.UserService = User;
    this.Config = Config;
    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$scope = $scope;

    const generalConfig = Config.getModuleConfig(Config.Modules.General);
    const signUpConfig = Config.getModuleConfig(Config.Modules.SignUp);
    const profileConfig = Config.getModuleConfig(Config.Modules.Profile);

    this.buildings = generalConfig.getClientBuildings();

    this.unitNumbersByBuilding = generalConfig.getClientUnits();

    this.residencyRelationType = profileConfig.getResidencyRelationTypes();
    this.defaultResidencyRelationType = profileConfig.getDefaultResidencyRelationType();

    this.userProto = {
      customFields: {},
      sendEmail: signUpConfig.getAdminAddUserSendEmailDefault()
    };
    this.errors = {};
    this.submitted = false;

    this.form = ["*"];
    this.model = {
      password: this.generatePassword()
    };
  }

  generatePassword() {
    var length = 8,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!%?$&",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  getUnitsByBuilding(building) {
    // If there is no building selected, return an empty array
    if (typeof building == 'undefined')
      return [];

    return this.unitNumbersByBuilding[building];
  }

  updateType(type) {
    this.type = type;

    this.schema = this.settings.data[this.type].schema || {};
    this.title = this.settings.data[this.type].title || "Add " + this.type;
    this.icon = this.settings.data[this.type].icon || "user";
    this.info = this.settings.data[this.type].info || '';
    this.contactType = this.settings.data.contactType || 'Home';
    this.buttonLabel = this.settings.data.buttonLabel || "OK";

    this.userProto.userTargetType = this.type;

    this.userProto.profile = {
      address: [{
        type: this.contactType
      }],
      phone: [{
        type: this.contactType
      }]
    };

    this.requiresResidencyStatus = this.settings.data[this.type].requiresResidencyStatus;

    if (this.requiresResidencyStatus) {

      this.userProto.residencyRelations = [
        {
          unit: '',
          building: '',
          type: this.type   // owner / renter
        }
      ];
    }
  }

  $onInit() {
    this.config = this.resolve.config;

    if (this.config.sort && this.config.sort === 'building') {
      this.buildings = this.buildings.sort();
    }

    this.SettingsService.getByName({name: 'user-add-config'}, settings => {
      this.settings = settings;
      this.types = settings.data.types;
      this.type = this.types[0];

      this.updateType(this.type);
    });
  };

  submit(form) {

    if (this.errors) { // Reset Mongoose errors
      Object.keys(this.errors).forEach(field => {
        this.$scope.$broadcast('schemaForm.error.'+field, 'mongoose', true);
      });
    }

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    var unflatten = require('flat').unflatten;

    this.user = angular.merge(this.userProto, unflatten(this.model,{delimiter:':'}));

    this.submitted = true;
    if (form.$valid) {

      this.user.profile.email = [{
        type: 'Main',
        address: this.user.email
      }];

      this.user.customFields.residencyRelations = this.userProto.residencyRelations;

      return this.UserService.createByAdmin(this.user, () => {
        this.dialogs.notify("The user has been created.", "The user account has been created.");
        this.close();
      }, (err) => {
        err = err.data;
        this.errors = {};
        // Update validity of form fields that match the mongoose errors
        if (err.name) {
          angular.forEach(err.errors, (error, field) => {

            if (field == "email") {
              this.$scope.$broadcast('schemaForm.error.'+field, 'mongoose', error.message);
            }

            /*
            form[field].$setValidity('mongoose', false);*/
            this.errors[field] = error.message;

          });
        }
      });
    }
  }

  getErrorKeys() {
    return Object.keys(this.errors);
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.userAdd', [])
  .component('userAdd', {
    template: require('./user-add.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: userAddComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/user-add/user-add.component.js